export const FETCH_WEBAPI_INFO = "fetchWebAPIInfo";
export const FETCH_VOCABULARY_SEARCH_RESULTS = "fetchVocabularySearchResults";
export const RESET_API_STORAGE = "resetApiStorage";
export const GET_AUTH_TOKEN = "getAuthToken";
export const FETCH_VOCABULARIES = "fetchVocabularies";
export const FETCH_CONCEPTS_RECORD_COUNT = "fetchConceptsRecordedCount";
